<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="!$route.query.customerId" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.customerId == undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <FilterGroup :title="$t('servicesystem.common_objects.customer.ownership')"
              :applied-filters="[parentcustomerfilter, customergroupfilter, departmentfilter]">
              <CustomerSelect v-model="parentcustomerfilter"
                :label="$t('servicesystem.common_objects.customer.parent_org')" clearable externaledit multiple
                class="mb-3">
              </CustomerSelect>
              <CustomerGroupSelect v-model="customergroupfilter" multiple clearable externaledit class="mb-3">
              </CustomerGroupSelect>
              <DepartmentSelect v-model="departmentfilter" multiple clearable externaledit>
              </DepartmentSelect>
            </FilterGroup>
            <FilterGroup :title="$t('servicesystem.common_objects.commonterms.properties')"
              :applied-filters="[publicfilter, hasActiveMachinesFilter]">
              <v-row v-if="publicModeEnabled" no-gutters justify="start" align="center" class="pb-3">
                <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.commonterms.public") }}:</p>
                <QButtonGroup v-model="publicfilter" :list="publicFilterOptions" :edit="true" dense noempty>
                </QButtonGroup>
              </v-row>
              <v-row no-gutters justify="start" align="center" class="pb-3">
                <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.customer.has_active_machines") }}:</p>
                <QButtonGroup v-model="hasActiveMachinesFilter" :list="activeMachinesOptions" :edit="true" dense
                  noempty>
                </QButtonGroup>
              </v-row>
            </FilterGroup>
            <DefaultLifeCycleFilterGroup :pk="pk">
            </DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getCustomerListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="40" ref="ListPane"
          :set-preview-function="openPreview" :openFunction="openItem" :pk="pk" :eventualDataType="eventualDataTypeKey"
          :exportFunction="exportCustomerList">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" :preselected="($route.query.customerId == item.Id)" previewable
              @click="openItem(item)" @openPreview="openPreview(item)" @closePreview="closePreview()">
            </ListItem>
          </template>

        </ListPane>
      </template>

      <template v-slot:preview>
        <PreviewPane :id="$route.query.customerId" :showToolbar="true" />
      </template>

    </Layout>

    <NewCustomerDialog :externaltrigger="dialogtrigger" @Update="handleadded" @Created="handleDialogCreate">
    </NewCustomerDialog>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import NewCustomerDialog from "@/components/Dialogs/NewCustomerDialog.vue";
import ListItem from "@/components/ListItems/CustomerListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import FilterGroup from "@/components/FilterGroup.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import CustomerGroupSelect from "@/components/Inputs/EntityDropdowns/CustomerGroupSelect2.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import PreviewPane from "@/views/job/newjob/cards/customer/PreviewCustomer.vue";
import Layout from "@/views/layouts/PreviewableList.vue";

export default {
  name: "AdminCustomerList",
  props: {},
  components: {
    FilterPane,
    FilterGroup,
    ListPane,
    PreviewPane,
    Layout,
    ListItem,
    NewCustomerDialog,
    DefaultLifeCycleFilterGroup,
    CustomerSelect,
    CustomerGroupSelect,
    DepartmentSelect,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "CL-",
      publicFilterOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.yes") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.no") },
      ],
      activeMachinesOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.yes") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.no") },
      ]
    };
  },

  created() {
    this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
  },

  mounted() { },

  methods: {
    openPreview(item) {
      var query = Object.assign({}, this.$route.query);
      query.customerId = item.Id;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/getPreviewCustomer", item.Id);
    },
    closePreview() {
      var query = Object.assign({}, this.$route.query);
      query.customerId = undefined;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
    },
    openItem(item) {
      var query = (this.$route.name == "CustomerList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewCustomer', params: { customerId: item.Id }, query })
    },

    handleDialogCreate(e) {
      this.handleadded(e);
      this.openItem(e);
    },

    handleadded(item) { this.$refs.ListPane.handleadded(item) },
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    exportCustomerList(filters) {
      this.exportCustomerListFromFilter(filters);
    },
  },

  computed: {
    eventualDataTypeKey() { return SRConst.EventualDataType.Customer; },
    dialogtrigger() { return this.$store.state.triggerevents.newDialogTrigger; },

    PreviewCustomer() { return this.$store.getters["JobHub/JobPreview/PreviewCustomer"]; },

    publicModeEnabled() { return this.$store.state.GlobalSettings.Features.PublicPortalEnabled; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes("filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          HasActiveMachines: this.hasActiveMachinesFilter,
          PublicState: this.publicfilter,
          ParentCustomerIdList: this.parentcustomerfilter,
          CustomerGroupIdList: this.customergroupfilter,
          DepartmentIdList: this.departmentfilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    parentcustomerfilter: {
      get() { return this.getQueryParam("filter-parentcustomer", []); },
      set(update) { this.setQueryParam("filter-parentcustomer", update); },
    },

    customergroupfilter: {
      get() { return this.getQueryParam("filter-customergroup", []); },
      set(update) { this.setQueryParam("filter-customergroup", update); },
    },

    departmentfilter: {
      get() { return this.getQueryParam("filter-department", []); },
      set(update) { this.setQueryParam("filter-department", update); },
    },

    publicfilter: {
      get() { return this.getQueryParam("filter-public", 0); },
      set(update) { this.setQueryParam("filter-public", update); },
    },

    hasActiveMachinesFilter: {
      get() { return this.getQueryParam("filter-activemachines", 0); },
      set(update) { this.setQueryParam("filter-activemachines", update); }
    }

  },

  watch: {},
};
</script>